// Shared formatting utilities for Outdoor Impact views
export function createFormatters(locale = (typeof navigator !== 'undefined' ? navigator.language : 'en-US')) {
  const numberFormatter = new Intl.NumberFormat(locale);
  const decimalFormatter = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  const percentFormatter = new Intl.NumberFormat(locale, { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 });

  const columnFormatters = {
    'GRP': v => safeNumberFormat(v, decimalFormatter),
    'Target pop. %': v => safeNumberFormat(v, percentFormatter),
    'Reach (%)': v => safeNumberFormat(v, percentFormatter)
  };

  function safeNumberFormat(value, formatter) {
    const num = parseFloat(value);
    return !isNaN(num) ? formatter.format(num) : value;
  }

  function formatValue(value, columnName) {
    if (columnName && columnFormatters[columnName]) return columnFormatters[columnName](value);
    if (typeof value === 'number') return numberFormatter.format(value);
    const parsed = parseFloat(value);
    if (!isNaN(parsed)) return numberFormatter.format(parsed);
    return value;
  }

  return { numberFormatter, decimalFormatter, percentFormatter, formatValue };
}

export const outdoorImpactFormatters = createFormatters();